// extracted by mini-css-extract-plugin
module.exports = {"LoaderWrapper":"styles_LoaderWrapper__QyMXL","Circle":"styles_Circle___wNsr"};